import { render, staticRenderFns } from "./IndicadoresHistoricoGastos.vue?vue&type=template&id=6efe7b22&"
import script from "./IndicadoresHistoricoGastos.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoGastos.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresHistoricoGastos.vue?vue&type=style&index=0&id=6efe7b22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports